import { render, staticRenderFns } from "./ParametroCredorBancarioCES.vue?vue&type=template&id=2cd87afc&"
import script from "./ParametroCredorBancarioCES.vue?vue&type=script&lang=js&"
export * from "./ParametroCredorBancarioCES.vue?vue&type=script&lang=js&"
import style0 from "./ParametroCredorBancarioCES.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports